import React from 'react';
import {Button, Checkbox, Collapse, Space, Typography, theme} from 'antd';
import {useTranslation} from 'react-i18next';
import './MetadataEntitySearchFields.css';

export const sectionFieldIds = section => [...new Set((section?.groups || []).flatMap(group => group.fields.map(field => field.id)))];

export function sectionForSelection(sections, selected) {
    if (!selected.length) return null;
    const matches = sections.filter(section => selected.every(id => sectionFieldIds(section).includes(id)));
    return matches.length === 1 ? matches[0].key : null;
}

export function selectionForSection(section, limit = 40) {
    const ids = sectionFieldIds(section);
    return ids.length <= limit ? ids : [];
}

export function nextSectionSelection(sections, currentKey, nextKey, selected) {
    if (!nextKey || nextKey === currentKey) return {key: currentKey, fields: selected};
    return {key: nextKey, fields: selectionForSection(sections.find(section => section.key === nextKey))};
}

export default function MetadataEntitySearchFields({sections, activeKey, selected, legacySelection, onSectionChange, onToggleField, onSelectAll, onSelectNone}) {
    const {t} = useTranslation();
    const {token} = theme.useToken();
    return <div style={{maxHeight: 420, overflowY: 'auto'}}>
        {legacySelection && <Typography.Text type="secondary">{t('legacy-entity-selection', 'Saved search includes fields from multiple sections. Choose a section to replace that selection.')}</Typography.Text>}
        <Collapse accordion activeKey={activeKey} onChange={key => onSectionChange(Array.isArray(key) ? key[0] || null : key || null)} items={sections.map(section => ({
            key: section.key,
            label: <Typography.Text strong>{section.label}</Typography.Text>,
            children: <>
                <Space style={{marginBottom: 8}}>
                    <Button size="small" type="link" onClick={onSelectAll}>{t('all', 'All')}</Button>
                    <Button size="small" type="link" onClick={onSelectNone}>{t('none', 'None')}</Button>
                </Space>
                {sectionFieldIds(section).length > 40 && <Typography.Text type="secondary">{t('entity-field-limit', 'Select at most 40 entity fields')}</Typography.Text>}
                <div className="metadata-entity-search-fields__groups">
                    {section.groups.filter(group => group.fields.length).map(group => <div key={group.label} style={{breakInside: 'avoid', border: `1px solid ${token.colorBorderSecondary}`, borderRadius: token.borderRadius, padding: 8}}>
                        <Typography.Text strong style={{display: 'block', marginBottom: 4}}>{group.label}</Typography.Text>
                        <Space direction="vertical" size={4}>{group.fields.map(field => <Checkbox key={field.id} checked={selected.includes(field.id)} onChange={() => onToggleField(field.id)}>{field.label}</Checkbox>)}</Space>
                    </div>)}
                </div>
            </>
        }))}/>
    </div>;
}
